import React from 'react';
import { motion } from 'framer-motion';
export function Hero() {
  return <section className="relative pt-32 pb-24 px-6 lg:px-8 overflow-hidden" data-id="element-126">
      {/* Video background */}
      <div className="absolute inset-0 z-0" data-id="element-127">
        <video autoPlay loop muted playsInline className="w-full h-full object-cover" data-id="element-128">
          <source src="https://thinkact.b-cdn.net/abstract1.mp4" type="video/mp4" data-id="element-129" />
        </video>

        {/* Gradient overlays for readability */}
        <div className="absolute inset-0 bg-gradient-to-br from-white/95 via-white/90 to-white/85" data-id="element-130"></div>
        <div className="absolute inset-0 bg-gradient-to-r from-[#0F52BA]/5 to-[#06B6D4]/5" data-id="element-131"></div>
      </div>

      {/* Decorative gradient accent (now layered over video) */}
      <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-gradient-to-br from-[#0F52BA]/10 to-[#06B6D4]/10 rounded-full blur-3xl z-0" data-id="element-132"></div>

      <div className="max-w-7xl mx-auto relative z-10" data-id="element-133">
        <div className="max-w-4xl" data-id="element-134">
          {/* Main headline */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-135">
            <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold leading-[1.1] mb-10" style={{
            fontFamily: 'Space Grotesk, sans-serif'
          }} data-id="element-136">
              <span style={{
              color: 'var(--color-navy)'
            }} data-id="element-137">
                Define bold{' '}
              </span>
              <span className="bg-gradient-to-r from-[#0F52BA] to-[#06B6D4] bg-clip-text text-transparent" data-id="element-138">
                bets.
              </span>
              <br data-id="element-139" />
              <span style={{
              color: 'var(--color-navy)'
            }} data-id="element-140">
                Validate in the{' '}
              </span>
              <span className="bg-gradient-to-r from-[#0F52BA] to-[#06B6D4] bg-clip-text text-transparent" data-id="element-141">
                real world.
              </span>
              <br data-id="element-142" />
              <span style={{
              color: 'var(--color-navy)'
            }} data-id="element-143">
                Scale{' '}
              </span>
              <span className="bg-gradient-to-r from-[#0F52BA] to-[#06B6D4] bg-clip-text text-transparent" data-id="element-144">
                what works.
              </span>
            </h1>
          </motion.div>

          {/* Subheadlines */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="space-y-4 mb-12" data-id="element-145">
            <p className="text-xl md:text-2xl font-semibold leading-relaxed" style={{
            color: 'var(--color-charcoal)'
          }} data-id="element-146">
              We help turn complex growth challenges into decisive action
            </p>
          </motion.div>

          {/* CTAs */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.4
        }} className="flex flex-col sm:flex-row gap-4" data-id="element-147">
            <a href="#contact" className="px-8 py-4 bg-gradient-to-r from-[#0F52BA] to-[#06B6D4] text-white text-base font-semibold rounded-full hover:shadow-xl hover:scale-105 transition-all duration-200 text-center" data-id="element-148">
              Start a Conversation
            </a>
          </motion.div>
        </div>
      </div>
    </section>;
}